import React from 'react';

export const NavToggleContext = React.createContext({});
